import { Map as iMap } from 'immutable';
import { addErrorToReport } from '@americanexpress/one-app-ducks';
import getCredoEligibility from '../requests/getCredoEligibility';
import getCredoPreferences from '../requests/getCredoPreferences';
import { TYPE_CREDO_OPT_IN } from '../constants';
const CREDO_PREFIX = 'axp-myca-root/CREDO/';
export const SET_CAN_REDIRECT = `${CREDO_PREFIX}SET_CAN_REDIRECT`;
export const SET_IS_DEFAULT = `${CREDO_PREFIX}SET_IS_DEFAULT`;
export const initialState = iMap({
  canRedirect: true,
  isDefault: false
});

// eslint-disable-next-line default-param-last -- redux
const reducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_CAN_REDIRECT:
      return state.set('canRedirect', action.canRedirect);
    case SET_IS_DEFAULT:
      {
        return state.set('isDefault', action.isDefault);
      }
    default:
      return state;
  }
};
export const getConfig = state => state.get('config');
export const getLocaleFilename = state => getConfig(state).get('localeFilename');
export const getCanCredoRedirect = (state, pathToData) => state.getIn(['modules', ...pathToData, 'canRedirect']);
export const setCanCredoRedirect = canRedirect => ({
  type: SET_CAN_REDIRECT,
  canRedirect
});
export const getIsCredoDefault = (state, pathToData) => state.getIn(['modules', ...pathToData, 'isDefault']);
export const setIsCredoDefault = isDefault => ({
  type: SET_IS_DEFAULT,
  isDefault
});
export const credoSideEffects = () => (dispatch, getState) => {
  // Log the eligibilty API error
  const state = getState();
  if (global.BROWSER) {
    const {
      error: credoEligibilityError
    } = getCredoEligibility(state);
    if (credoEligibilityError) {
      dispatch(addErrorToReport(credoEligibilityError, {
        message: 'customer-dashboard-utils - eligibility api error',
        msgType: 'MYCA-Tenant',
        collectionMethod: 'error'
      }));
    }
    const {
      error: credoPreferencesError
    } = getCredoPreferences(state, [TYPE_CREDO_OPT_IN]);
    if (credoPreferencesError) {
      dispatch(addErrorToReport(credoPreferencesError, {
        message: 'customer-dashboard-utils - readMemberPreferences api error',
        msgType: 'MYCA-Tenant',
        collectionMethod: 'error'
      }));
    }
  }
};
export default reducer;